import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  root: {
    display: 'flex'
  }
})

function View (props) {
  const styles = useStyles()
  const { className, children, ...args } = props
  const boxStyle = className ? `${styles.root} ${className}` : styles.root
  return (
    <div className={boxStyle} {...args}>
      { children }
    </div>
  )
}

export default View